import React, { useState } from 'react';
import MapaSeccion from './Mapa';
import BarrasSeccion from './Barras';
import { HEIGHT_BODY, WIDTH_RIGHT_PANEL, esCelular } from '../Config';

interface BodyProps {
    setCodigoDivipola: (codigo: string) => void;
    filtrar: any;
    codigoDivipola: any;
}

const Body: React.FC<BodyProps> = ({ setCodigoDivipola, filtrar, codigoDivipola }) => {
    const [isPanelExpanded, setIsPanelExpanded] = useState(false);

    const togglePanel = () => {
        setIsPanelExpanded(!isPanelExpanded);
    };

    if (esCelular) {
        return (
            <div style={{ width: "100%", height: HEIGHT_BODY, position: "relative" }}>
                <MapaSeccion 
                    setCodigoDivipola={setCodigoDivipola} 
                    filtrar={filtrar} 
                    codigoDivipola={codigoDivipola} 
                />
                <div style={{
                    position: "absolute",
                    right: 0,
                    top: 0,
                    height: "100%",
                    width: isPanelExpanded ? WIDTH_RIGHT_PANEL : "40px",
                    backgroundColor: "#ffffff",
                    transition: "width 0.3s ease",
                    borderLeft: "1px solid #d3d3d3",
                    overflow: "hidden"
                }}>
                    <button
                        onClick={togglePanel}
                        style={{
                            position: "absolute",
                            left: 0,
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "40px",
                            height: "40px",
                            border: "none",
                            backgroundColor: "#f0f0f0",
                            cursor: "pointer"
                        }}
                    >
                        {isPanelExpanded ? "→" : "←"}
                    </button>
                    <div style={{ marginLeft: "40px" }}>
                        <BarrasSeccion 
                            filtrar={filtrar} 
                            codigoDivipola={codigoDivipola} 
                            setCodigoDivipola={setCodigoDivipola} 
                        />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div style={{ width: "100%", height: HEIGHT_BODY, display: "flex" }}>            
            <MapaSeccion 
                setCodigoDivipola={setCodigoDivipola} 
                filtrar={filtrar} 
                codigoDivipola={codigoDivipola} 
            />            
            <div style={{ width: WIDTH_RIGHT_PANEL, backgroundColor: "#ffffff", borderLeft: "1px solid #d3d3d3" }}>
                <BarrasSeccion 
                    filtrar={filtrar} 
                    codigoDivipola={codigoDivipola} 
                    setCodigoDivipola={setCodigoDivipola} 
                />
            </div>
        </div>
    );
};

export default Body;